import { render, staticRenderFns } from "./SurveyList.vue?vue&type=template&id=8f896078&scoped=true&"
import script from "./SurveyList.vue?vue&type=script&lang=ts&"
export * from "./SurveyList.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyList.vue?vue&type=style&index=0&id=8f896078&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f896078",
  null
  
)

export default component.exports